var scrollToAnchorOffSet = 120;
var sWin = null;
var nWin = null;
var notesUrl = null;
const readCheckbox = document.getElementById('read')

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };
 
  
$(function () {

    // Add class if edge
    if (/Edge/.test(navigator.userAgent)) {
        $('body').addClass('ie ie--edge');
    }

    // Add class if IE 11
    var is_ie11 = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    if (is_ie11) {
        $('body').addClass('ie ie--11');
    }

    // Add class if IE10
    var is_ie10 = navigator.appVersion.indexOf("MSIE 10") !== -1;
    if (is_ie10) {
        $('body').addClass('ie ie--10');
    }

    // Add class if safari
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (is_safari) {
        $('body').addClass('body--safari');
    }

    // Remove empty paragraphs
    $('p').filter(function(){ return $.trim(this.innerHTML)==="&nbsp;" }).remove();


    /* === Add aria labels to owl carousel buttons === */
    $('.owl-carousel').each(function() {
        //Find each set of dots in this carousel
        $(this).find('.owl-dot').each(function(index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', index + 1);
        });
    });


    /* === Custom bullet list === */
    $('.li--tickbox').closest('ul').addClass('ul--stripped');


});


function scrollToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}
function scrollToAnchorID(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}

function scrollToAnchorOffset(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}
function scrollToAnchorIDOffset(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}

function owl_Carousel_Init(element, childElements, autoSlide_user, autoplayTimeout_user, slideSpeedTransition) {

    if (element === null || typeof element === 'undefined' || element === '') {
        alert('You need to specify an element for the owl carousel slider to attach to');
    }
    if (childElements === null || typeof childElements === 'undefined' || childElements === '') {
        alert('You need to specify the slide elements for the owl carousel slider to attach to');
    }
    if (autoplayTimeout_user === null || typeof autoplayTimeout_user === 'undefined' || autoplayTimeout_user === '') {
        autoplayTimeout_user = 5000;
    }
    if (slideSpeedTransition === null || typeof slideSpeedTransition === 'undefined' || slideSpeedTransition === '') {
        slideSpeedTransition = 1000;
    }


    var bannerSlide = $(element);

    bannerSlide.each(function (i) {
        $(this).attr('id', i + 1);
        var item_count = parseInt($(this).find(childElements).length);  // '.main-banner__slide'
        var true_false = false;
        if (item_count > 1) {
            true_false = true;
        } else {
            true_false = false;
        }
        var autoSlide = true_false;

        if (true_false === true) {
            // Only do this check if true. Don't want to be setting auto scroll if only one element
            autoSlide = autoSlide_user;
        } else {
            autoSlide = false;
        }

        var owl = $(this).owlCarousel({
            items: 1,
            margin: 0,
            loop: true,
            dots: true,
            nav: false,
            touchDrag: true_false,
            mouseDrag: true_false,
            lazyLoad: true,
            autoplay: autoSlide,
            autoplayTimeout: autoplayTimeout_user,


            navSpeed: slideSpeedTransition, // One of these has to work?
            smartSpeed: slideSpeedTransition,
            autoplaySpeed: slideSpeedTransition,
            fluidSpeed: slideSpeedTransition
        });

        owl.on('changed.owl.carousel', function (e) {
            if (autoSlide) {
                owl.trigger('stop.owl.autoplay');
                owl.trigger('play.owl.autoplay');
            }

            // Stop any playing videos
            $('.video-container iframe').each(function () {
                var el_src = $(this).attr("src");
                $(this).attr("src", el_src);
            });

        });
    });
}

//function nextSlide(slideId, total, note) {
//    //var note = $(this).data("notes");
//    total = total - 1;

//    $(".slide--" + slideId + "--active").addClass("slide--hidden");
//    $(".slide--" + slideId + "--active").addClass("slide--" + slideId + "--hidden");
//    $(".slide--" + slideId + "--active").removeClass("slide--" + slideId + "--active");

//    var nxtSlide = ++slideId;
    
//    if (nxtSlide > total) {
//        nxtSlide = 0;
//    }
//    $(".slide--" + nxtSlide + "--hidden").addClass("slide--" + nxtSlide + "--active");
//    $(".slide--" + nxtSlide + "--hidden").removeClass("slide--hidden");
//    $(".slide--" + nxtSlide + "--hidden").removeClass("slide--" + nxtSlide + "--hidden");

//    if (note) {
//        openNotes(note);
//    }
    
//}

//function prevSlide(slideId, total, note) {
//    //var note = $(this).data("notes");
//    total = total - 1;

//    $(".slide--" + slideId + "--active").addClass("slide--hidden");
//    $(".slide--" + slideId + "--active").addClass("slide--" + slideId + "--hidden");
//    $(".slide--" + slideId + "--active").removeClass("slide--" + slideId + "--active");

//    var prvSlide = --slideId;

//    if (prvSlide < 0) {
//        prvSlide = total;
//    }
//    $(".slide--" + prvSlide + "--hidden").addClass("slide--" + prvSlide + "--active");
//    $(".slide--" + prvSlide + "--hidden").removeClass("slide--hidden");
//    $(".slide--" + prvSlide + "--hidden").removeClass("slide--" + prvSlide + "--hidden");

//    if (note) {
//       openNotes(note);
//    }
   
//}


function changeNotesWindow(slideId) {
    if (notesUrl) {
        console.log('changes notes to : %o', slideId);
        nWin.changeSlide(slideId);
    } else {
        console.log('notes disabled');
    }
}

$('.slide-launch').click(function () {
    var url = $(this).data("url");
    notesUrl = $(this).data("notes");
    var title = $(this).data("title");

    var left = (screen.width - 1100) / 4;
    var top = (screen.height - 800) / 4;

    sWin = window.open("slide", title, 'height=850,width=1100,top='+top+',left='+left+',popup');
    sWin.document.write('<html lang="en"><head><title>'+title+'</title> <link rel="stylesheet" href="/css/_dist/styles.css" /> <script type="text/javascript" src="/js/base/jquery-3.5.1.js"></script><script type="text/javascript" src="/js/_dist/compiled.min.js"></script></head><body><iframe src="' + url +'" width="100%" height="100%" style="border:none;"></iframe></body></html>');
    sWin.document.close();

    if (notesUrl) {
        openNotes(notesUrl)
    }
});

$('.slide-navto').click(function() {
    var url = $(this).data("url");
    notesUrl = $(this).data("notes");
    var title = $(this).data("title");

    sWin = window.open(url, title, 'height=850,width=1100,popup');
    sWin.document.write('<html lang="en"><head><title>' + title + '</title> <link rel="stylesheet" href="/css/_dist/styles.css" /> <script type="text/javascript" src="/js/base/jquery-3.5.1.js"></script><script type="text/javascript" src="/js/_dist/compiled.min.js"></script></head><body><iframe src="' + url + '" width="100%" height="100%" style="border:none;"></iframe></body></html>');
    sWin.document.close();

    if (notesUrl) {
        openNotes(notesUrl)
    }
});

$('.note-next').click(function () {
    //var url = $(this).data("notes");
    var opener = window.opener;
    nWin = window.open('', 'Notes');
    nWin.document.getElementById("splide__arrow--next");
});

$('.fa-angle-left').click(function () {
    var url = $(this).data("notes");

    openNotes(url);
});

function openNotes(url) {
    //var note = $(this).data("note");
    notesUrl = url;
    nWin = window.open(url, "Slide Notes", 'height=400,width=500,popup');
    console.log(nWin);
    //nWin.document.write('<html lang="en"><head><title>"Notes"</title><link rel="stylesheet" href="/css/_dist/styles.css" /> <script type="text/javascript" src="/js/base/jquery-3.5.1.js"></script><script type="text/javascript" src="/js/_dist/compiled.min.js"></script></head><body><iframe name="Slide Notes" src="'+ url +'" width="100%" height="100%" style="border:none;"></iframe></body></html>');
    /*nWin.document.close();*/
    /*var notes = window.open("", title, windowFeatures);*/
    //notes.document.body.innerHTML = 
}

function openMenu() {
    slide_menu = $('.slide__menu');
    popup = $('.slide__menu--popup');

    popup.toggleClass('slide__menu--popup--active');

    if ($(this).attr('aria-expanded') === 'true') {
        $(this).attr('aria-expanded', 'false');
    } else {
        $(this).attr('aria-expanded', 'true');
    }
}

readCheckbox.addEventListener('change', (event) => {
    if (event.target.checked) {
        $('.panel-row--umbraco-form').removeClass('hidden');
    }
    else {
        $('.panel-row--umbraco-form').addClass('hidden');
    }
})

function setResetId(resetId) {
    //let date = new Date();
    //date.setTime(date.getDate() + 1);
    //let expires = date.toUTCString();
    //document.cookie = "userResetId=" + resetId + ";" + "expires=" + expires + ";path=/";
    console.log("id set")
    Cookies.set('userResetId', resetId, { expires: 1 },)
}

function getResetId(resetId) {
    var c = document.cookie.split(';');
}